import { Component, Inject, OnInit } from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminAddDriverComponent } from "../admin-add-driver/admin-add-driver.component";
import { AdminService } from "../admin.service";
@Component({
  selector: "app-admin-edit-drivers",
  templateUrl: "./admin-edit-drivers.component.html",
  styleUrls: ["./admin-edit-drivers.component.css"],
})
export class AdminEditDriversComponent implements OnInit {
  matDialogueEdit!: MatDialogRef<AdminAddDriverComponent>;
  driverData: any;
  NotesData: any;
  truckName: any;
  reasons: boolean = true;
  emailregex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/;

  constructor(
    private matDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: AdminService,
    private router: Router,
    private snackBar: MatSnackBar,
    private matdialogref: MatDialogRef<AdminEditDriversComponent>
  ) {}

  ngOnInit(): void {
    this.driverData = this.data;
    if (this.driverData.driver_remarks == "") {
      this.reasons = false;
    }
    this.getTrucks();
    this.GetNotes();
  }

  public getTrucks() {
    let token = localStorage.getItem("adminToken");
    this.service.trucksGet(token).subscribe(
      (response: any) => {
        if (response.status === 200) {
          response.body.data.filter((ele: any) => {
            if (ele._id == this.driverData.truck_id) {
              this.truckName = ele.truck_number;
            }
          });
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  public GetNotes() {
    let token = localStorage.getItem("adminToken");
    this.service.GetNotes(this.data._id, token).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.NotesData = response.body.data.filter(
            (item: any) => item.module_type === "driver"
          );
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  public editDriver() {
    let matDialogueEdit = this.matDialog.open(AdminAddDriverComponent, {
      width: "80vw",
      height: "80vh",
      data: this.driverData,
      autoFocus: false,
    });
    matDialogueEdit.afterClosed().subscribe((res) => {
      this.matdialogref.close({ success: "close" });
    });
  }

  public close() {
    this.matdialogref.close();
  }
}
